// extracted by mini-css-extract-plugin
module.exports = {"indicator":"Loading_indicator__1-iPQ","loading":"Loading_loading__1qEwJ","modalContent":"Loading_modalContent__2W24I"};